import usePaginationState from "gui/browse-shared/usePaginationState";

import { useActiveContext } from "shared/ContextSwitcher/store";

import useFreetextFilterState from "gui/browse-shared/useFreetextFilterState";
import { useMemo } from "react";
import { SessionWithUser } from "lib/users/types";

import usePublicnessState from "gui/browse-shared/usePublicnessState";
import useShowMaterializedViewsState from "gui/browse-shared/useShowMaterializedViewsState";
import useShowArchivedState from "gui/browse-shared/useShowArchivedState";
import useOrderState from "./useOrderState";

import { useActiveTab } from "./useActiveTab";
import { DashboardsResults } from "./DashboardsResults/DashboardsResults";
import { QueriesResults } from "./QueriesResults/QueriesResults";
import { ListFolders } from "./ListFolders/ListFolders";
import { Filter } from "./Filters";

export function TabContent(props: { session: SessionWithUser }) {
  const { activeTab } = useActiveTab();

  const { freetextFilter, freetextFilterDebounced } = useFreetextFilterState();
  const selectedOwner = useActiveContext();
  const [publicness] = usePublicnessState();
  const [showArchived] = useShowArchivedState();
  const [showMaterialized] = useShowMaterializedViewsState();

  const filter = useMemo(
    (): Filter => ({
      freetext: freetextFilterDebounced,
      owner: selectedOwner,
      publicness,
      is_archived: showArchived,
      is_matview: showMaterialized,
    }),
    [
      freetextFilterDebounced,
      selectedOwner,
      publicness,
      showArchived,
      showMaterialized,
    ]
  );

  const [order] = useOrderState();
  const [page] = usePaginationState();

  const apiParams = useMemo(() => ({ filter, order, page, pageSize: 10 }), [
    filter,
    order,
    page,
  ]);

  const hasFiltersApplied =
    freetextFilter !== "" ||
    publicness !== "all" ||
    showArchived ||
    showMaterialized ||
    order.by !== "updated_at";

  switch (activeTab) {
    case "library":
      return (
        <div id="library">
          <ListFolders session={props.session} />
        </div>
      );

    case "queries":
      return (
        <div id="queries">
          <QueriesResults
            apiParams={apiParams}
            session={props.session}
            hasFiltersApplied={hasFiltersApplied}
          />
        </div>
      );

    case "dashboards":
      return (
        <div id="dashboards">
          <DashboardsResults
            apiParams={apiParams}
            session={props.session}
            hasFiltersApplied={hasFiltersApplied}
          />
        </div>
      );
  }
}
